import {useSelector} from 'react-redux'

import {selectCustomers} from '../../Organisms/Customers'
import {DataScope, NormalizedFeatures, useFeaturesState} from '../../Organisms/Features'
import {AppState} from '../../Root.store'

const getConstraintCountries = (dataScope: DataScope | string): string[] => {
  const scope: DataScope = typeof dataScope === 'string' ? JSON.parse(dataScope) : dataScope
  if (!scope.countryId) return []
  const countries = Array.isArray(scope.countryId) ? scope.countryId : [scope.countryId]
  return countries.map((country) => country.toUpperCase())
}

export const isFeatureEnabledForCountry = (
  featureName: string,
  normalized: NormalizedFeatures,
  countryId?: string | null
): boolean => {
  if (!countryId) return false
  const country = countryId.toUpperCase()
  const constraints = normalized[featureName]?.constraints ?? []

  const matching = constraints.filter((c) => getConstraintCountries(c.dataScope).includes(country))
  return matching.length > 0 && matching.every((c) => c.enabled)
}

// Country-restricted flags must be evaluated against the selected customer, not the user's scope.
export const useIsFeatureEnabledForSelectedCustomerCountry = (featureName: string): boolean => {
  const {normalized} = useFeaturesState()
  const customerCountry = useSelector(
    (state: AppState) => selectCustomers(state).selectedCustomer?.countryId
  )
  const userCountry = useSelector((state: AppState) => state.userProfile.userProfile?.country)

  return isFeatureEnabledForCountry(featureName, normalized, customerCountry || userCountry)
}
